import { useContext, useEffect, useState } from "react";
import LeftBox from "./components/LeftBox";
import styles from './index.module.scss'
import { message, Tabs } from "antd";
import MobileAndVerifyForm from "./components/MobileAndVerifyForm";
import AccountAndPwdForm from "./components/AccountAndPwdForm";
import WechatScanForm from "./components/WechatScanForm";
import eventBus from "@utils/eventBus";
import { AppContext } from "@utils/AppContext";
import ForgotPwdForm from "./components/ForgotPwdForm";
import EmailRegisterForm from "./components/EmailRegisterForm";
import { useLocation, useNavigate } from "react-router-dom";

const Login = (props) => {
    const [activeKey, setActiveKey] = useState(props.activeKey || "1")
    const [mobile, setMobile] = useState()
    const items = [{
        key: "1", label: '验证码登录',
    }, {
        key: "2", label: '密码登录',
    }]
    return (
        <>
        <Tabs
            centered
            activeKey={activeKey}
            className={styles.LoginTabs}
            items={items}
            onChange={key => setActiveKey(key)}
        />
        {
            activeKey == "1" ? <MobileAndVerifyForm mobile={mobile} onMobileChange={val => setMobile(val)} loginCallback={props.loginCallback} onEmailRegiste={props.onEmailRegiste} /> :
            activeKey == "2" ? <AccountAndPwdForm mobile={mobile} onMobileChange={val => setMobile(val)} loginCallback={props.loginCallback} onForgotPwd={props.onForgotPwd}/> :null
        }
        </>
    )
}

export default function LoginModal (props) {
    const location = useLocation();
    const navigate = useNavigate();
    const {setHasToken} = useContext(AppContext)
    const [mode, setMode] = useState(0) // 0-normal, 1-忘记密码，2-邮箱注册，

    const closeFunc = (logged, isRegister) => {
        if (logged) {
            sessionStorage.removeItem('taskCache_model')
            sessionStorage.removeItem('taskCache_dressform')
            sessionStorage.removeItem('taskCache_clothes')
            sessionStorage.removeItem('taskCache_commodity')
            sessionStorage.removeItem('taskCache_tryonVideo')
            sessionStorage.removeItem('taskCache_commodityVideo')
            message.success('登录成功', 5)
        }
        // const urlParams = new URLSearchParams(location.search)
        // const redirect = urlParams.get('redirect')
        // if (redirect) navigate(redirect)
    }

    const handleLogin = (data) => {
        if (!data) return closeFunc(false)
        eventBus.emit('tokenValid') // 通知token有效，详见注册tokenValid的组件逻辑
        localStorage.setItem('noPassword', data.noPassword)
        localStorage.setItem('token', data.token)
        localStorage.setItem('channel', data.channel)
        setHasToken(true)
        closeFunc(true, data.register)
    }

    const [activeKey, setActiveKey] = useState("1")
    const handleBack = (value="1") => {
        setActiveKey("2")
        setMode(0)
    }

    return (
        <div className={styles.login_box}>
            {/* <LeftBox /> */}
            <div className={styles.RightBox}>
                <div className={styles.RightContent}>
                    {mode == 1 ? null :<p className={styles.r_title}>即刻体验PSAI Master</p>}
                    <div className={styles.r_content}>
                    {
                        mode == 0 ?
                        <Login
                            activeKey={activeKey}
                            loginCallback={handleLogin}
                            onForgotPwd={() => setMode(1)}
                            onEmailRegiste={() => setMode(2)}
                            closeFunc={closeFunc}
                        /> :
                        mode == 1 ?
                        <ForgotPwdForm
                            onBack={handleBack}
                        /> :
                        <EmailRegisterForm
                            loginCallback={handleLogin}
                            onBack={handleBack}
                        />
                    }
                    </div>
                    {
                        mode == 1 ? null :
                        <div className={styles.r_footer}>
                            <p className={styles.r_p}>
                                <span className={styles.span_normal}>登录即表示您已阅读并同意本产品的</span>
                                <a className={styles.span_click} href='/服务协议.htm' target="_blank">服务协议</a> 和&nbsp;
                                <a className={styles.span_click} href='/隐私政策.htm' target="_blank">隐私政策</a>
                            </p>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}